/* global System */
// register component(s) with react habitat

export default {
  SendinblueFormModal: () =>
    System.import(
      /* webpackChunkName: "SendinblueFormModal" */
      './component'
    ),
}
